import Script from 'next/script';
import config from 'lib/config';

const script = `(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src="https://maps.googleapis.com/maps/api/js?"+e;d[q]=f;a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({key: '${config.googleMapsApiKey}'});`;
const initMapScript = `
  async function initMap() {
    // Request libraries when needed, not in the script tag.
    const { Places } = await google.maps.importLibrary("places");
  }

  initMap();
`;
export function InitMap(): JSX.Element {
  return (
    <>
      <Script dangerouslySetInnerHTML={{ __html: initMapScript }} id="initMap" />
    </>
  );
}

export default function GoogleMaps(): JSX.Element {
  return (
    <>
      <Script id="google-maps-script" dangerouslySetInnerHTML={{ __html: script }} />
    </>
  );
}
